/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameRank.vue?vue&type=template&id=66bd9c42&scoped=true"
import script from "./popGameRank.vue?vue&type=script&lang=js"
export * from "./popGameRank.vue?vue&type=script&lang=js"
import style0 from "./popGameRank.vue?vue&type=style&index=0&id=66bd9c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd9c42",
  null
  
)

export default component.exports